// extracted by mini-css-extract-plugin
export default {"container":"LiveVideo_container__Annju","nor-screen":"LiveVideo_nor-screen__6FBe1","fullscreen":"LiveVideo_fullscreen__YD+89"};